import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const FALLBACK = [
  { title: "Anniversary & Love Story", occasion: "Anniversary", tagline: "Immortalize your inside jokes, milestone dates & sweet memories", badge: "Most Popular", img: "https://images.pexels.com/photos/3761519/pexels-photo-3761519.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { title: "Birthday Banger", occasion: "Birthday", tagline: "Turn their chaotic habits into a catchy, upbeat anthem", badge: "High Energy", img: "https://images.unsplash.com/photo-1544563422-a46c75a351e5?crop=entropy&cs=srgb&fm=jpg&q=85" },
  { title: "Wedding First Dance", occasion: "Wedding", tagline: "Dance to an original song created just for your vows", badge: "Romantic", img: "https://images.pexels.com/photos/10360898/pexels-photo-10360898.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { title: "Proposal & Romance", occasion: "Proposal", tagline: "The ultimate surprise before popping the big question", badge: "Unforgettable", img: "https://images.unsplash.com/photo-1714647211960-540efeff3c90?crop=entropy&cs=srgb&fm=jpg&q=85" },
  { title: "Long Distance & Miss You", occasion: "Long Distance", tagline: "Bridge the miles with a melody sent straight to their phone", badge: "Tear-Jerker", img: "https://images.pexels.com/photos/29801854/pexels-photo-29801854.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { title: "Apology & Thank You", occasion: "Apology", tagline: "Say what words alone can't with a heartfelt custom track", badge: "Heartfelt", img: "https://images.unsplash.com/photo-1713256449316-1a4067517c3b?crop=entropy&cs=srgb&fm=jpg&q=85" },
];

const badgeClses = ["bg-pink text-white", "bg-sunny text-ink", "bg-grape text-white", "bg-mint text-ink", "bg-cobalt text-white", "bg-tangerine text-white"];

export default function Occasions({ content, onOrder }) {
  const occasions = content?.occasions?.length ? content.occasions : FALLBACK;
  return (
    <section id="occasions" className="py-20 sm:py-28 scroll-mt-24" data-testid="occasions-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6 }} className="text-center">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-pink font-semibold mb-4">One song, every moment</p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl tracking-tight leading-[1.1]">
            Choose an occasion &amp; <span className="text-pink">start crafting</span>
          </h2>
          <p className="mt-4 text-plum font-medium text-sm sm:text-base">Click any card — your order form opens pre-filled.</p>
        </motion.div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {occasions.map((o, i) => (
            <motion.button
              key={o.title + i}
              data-testid={`occasion-card-${(o.occasion || o.title).toLowerCase().replace(/[\s/]+/g, "-")}`}
              onClick={() => onOrder(o.occasion ? { occasion: o.occasion } : {})}
              initial={{ opacity: 0, y: 32, rotate: i % 2 ? 1.5 : -1.5 }}
              whileInView={{ opacity: 1, y: 0, rotate: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.1, type: "spring", bounce: 0.3 }}
              className="sticker-card group relative rounded-3xl bg-white p-4 text-left"
            >
              <div className="relative h-48 rounded-2xl overflow-hidden border-2 border-ink">
                <img src={o.img} alt={o.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" loading="lazy" />
                {o.badge && (
                  <span className={`sticker absolute top-3 left-3 rounded-full border-2 border-ink px-3 py-1 font-display font-semibold text-[11px] rotate-[-4deg] ${badgeClses[i % badgeClses.length]}`}>
                    {o.badge}
                  </span>
                )}
              </div>
              <div className="pt-4 pb-1 px-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-display font-semibold text-xl leading-tight">{o.title}</h3>
                  <span className="btn-pop w-9 h-9 shrink-0 rounded-full bg-sunny border-2 border-ink flex items-center justify-center shadow-[2px_2px_0_#2D1A32]">
                    <ArrowUpRight size={16} />
                  </span>
                </div>
                <p className="mt-1.5 text-sm text-plum font-medium">{o.tagline}</p>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
